"use client";

import { Menu } from "@base-ui/react/menu";
import { Check } from "lucide-react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { cn } from "@/lib/utils";
import SortIcon from "../icons/sort";
import { Button } from "../ui/button";

const SORT_OPTIONS = [
  { label: "İlgi Düzeyi (Önerilen)", value: "6" },
  { label: "En Yeni", value: "0" },
  { label: "En Çok Beğenilen", value: "4" },
  { label: "En Çok Yorumlanan", value: "5" },
] as const;

const ContentSortMenu = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const activeSort = searchParams.get("sort") ?? SORT_OPTIONS[0].value;

  const handleSelect = (value: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("sort", value);
    params.set("page", "1");
    router.push(`${pathname}?${params.toString()}`);
  };

  return (
    <Menu.Root>
      <Menu.Trigger
        render={
          <Button
            className="flex flex-row items-center gap-2 text-neutral-800 font-bold text-sm leading-5 mr-3 cursor-pointer shrink-0"
            variant="outline"
          />
        }
      >
        Sırala <SortIcon className="w-4 h-4 stroke-brand-blue-600" />
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Positioner align="start" sideOffset={4}>
          <Menu.Popup className="min-w-64 rounded-2xl border border-neutral-200 bg-white shadow-lg py-1 outline-none z-50 overflow-clip">
            {SORT_OPTIONS.map((option) => {
              const isActive = option.value === activeSort;
              return (
                <Menu.Item
                  className={cn(
                    "flex items-center justify-between gap-2 px-4 py-3 text-sm cursor-pointer outline-none border-b border-neutral-100 last:border-b-0 hover:bg-neutral-50 data-highlighted:bg-neutral-50",
                    isActive
                      ? "text-brand-blue-600 font-bold bg-brand-blue-100 hover:bg-brand-blue-100 data-highlighted:bg-brand-blue-100"
                      : "text-neutral-800",
                  )}
                  key={option.value}
                  onClick={() => handleSelect(option.value)}
                >
                  {option.label}
                  {isActive && <Check className="size-4" />}
                </Menu.Item>
              );
            })}
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  );
};

export default ContentSortMenu;
